import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLazyGetStateQuery } from "@/services/api";
import { useAppDispatch, useAppSelector } from "@/services/store";
import {
  appIsAuthenticatedSelector,
  logout,
  setAuthStatus,
  shouldEnterPinSelector,
} from "@/services/auth";
import { appRouterPaths } from "@/services/navigation";
import { signUpActions, SignUpStep } from "@/features/sign-up";
import { FlowType, paymentSelectors } from "@/features/payment-form";

export const useAuthInitializer = () => {
  const shouldEnterPin = useAppSelector(shouldEnterPinSelector);
  const appIsAuthenticated = useAppSelector(appIsAuthenticatedSelector);
  const flowType = useAppSelector(paymentSelectors.selectFlowType);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [getState] = useLazyGetStateQuery();

  const handleGetState = () => {
    if (appIsAuthenticated) {
      getState()
        .unwrap()
        .then((res) => {
          dispatch(setAuthStatus(res.state));
          navigate(appRouterPaths.checkStatus);
        })
        .catch(() => {
          dispatch(logout());
          navigate(appRouterPaths.logIn);
        });
    }
  };

  useEffect(() => {
    switch (flowType) {
      case undefined:
      case null:
        handleGetState();
        break;

      case FlowType.SIGN_UP:
        dispatch(signUpActions.goToStep(SignUpStep.CheckPayment));
        navigate(appRouterPaths.signUp);
        break;

      case FlowType.UPDATE_SUBSCRIPTION:
      case FlowType.RENEW_SUBSCRIPTION:
        navigate(appRouterPaths.checkPayment);
        break;
    }
  }, [shouldEnterPin]);
};
